import * as types from './mutation_types'
import { map, cloneDeep } from 'lodash'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      view: {},
      setActiveError: '',
      isActiveLoading: false
    })
  },

  [types.SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.SET_ITEMS] (state, items) {
    Object.assign(state, { items })
  },

  [types.SET_ALL_ITEMS] (state, { items, clearPrev }) {
    if (!clearPrev) {
      items = state.items.concat(items)
    }
    Object.assign(state, { items })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.SET_LOADING] (state, value) {
    Object.assign(state, { isLoading: value })
  },

  [types.SET_VIEW] (state, view) {
    Object.assign(state, { view })
  },

  [types.SET_ITEM] (state, item) {
    state.items = map(state.items, (x) => {
      if (x.id === item.id) x = cloneDeep(item)
      return x
    })
  },

  [types.SET_ITEM_ACTIVE] (state, data) {
    let activeValue = data.active
    if (data.toggle) {
      activeValue = !activeValue
    }

    state.items = map(state.items, (item) => {
      if (item['@id'] === data.id) {
        item.active = activeValue
      }
      return item
    })
  },

  [types.SET_ITEM_ACTIVE_ERROR] (state, error) {
    Object.assign(state, { setActiveError: error })
  },

  [types.SET_ITEM_ACTIVE_LOADING] (state) {
    Object.assign(state, { isActiveLoading: !state.isActiveLoading })
  }
}
